/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import { usePortalToken } from 'hooks';

import { HelmetProvider } from 'react-helmet-async';
import { GlobalStyle } from 'globalStyle';
// import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route, useLocation as useLoc } from 'wouter';
import { Page, withProfile } from 'Layout';
// import { closePopUp } from 'store/popup';
import { routes } from 'routes';
import { withSuspense } from 'hoc/withSuspense';
import { Error } from 'page/Error';
import { userType } from 'types';
import { Loading } from 'components/Loading';
import Box from '@material-ui/core/Box';
import { withPrivateRoute } from 'hoc/withPrivateRoute';
import { SessionExpiresModal } from 'components/Modals';
import MaintenanceModal from 'components/Modals/Maintenance';
import { PageAkademia } from 'LayoutAkademia';
import { ConstructionGate } from 'page/InConstruction';
// context

import { useLocation } from 'hooks/useLocation';
import ButtonWhatsapp from 'components/ButtonWhatsapp';

const AkademiaHome = React.lazy(() => import('page/LandingAkademia'));
const HomePage = React.lazy(() => import('page/Home'));
const FinanceProject = React.lazy(() => import('page/FinanceProject'));
const FrequentQuestions = React.lazy(() => import('page/FrequentQuestions'));
const TermsAndConditions = React.lazy(() => import('page/TermsAndConditions'));
const DataProcessingPolicy = React.lazy(() => import('page/DataProcessingPolicy'));
const SendMessage = React.lazy(() => import('page/ContactUs/SendMessage'));
const ComplaintsForm = React.lazy(() => import('page/ContactUs/ComplaintsForm'));
const Project = React.lazy(() => import('page/SingleProject'));
const InConstruction = React.lazy(() => import('page/InConstruction'));
const Resources = React.lazy(() => import('page/Resources'));
const Correspondents = React.lazy(() => import('page/Correspondents'));
const WhatDo = React.lazy(() => import('page/WhatDo'));
const Warranty = React.lazy(() => import('page/Warranty'));
const ConditionsAndCharacteristics = React.lazy(() => import('page/ConditionsAndCharacteristics'));

// user
const CrowdfundingAkademia = React.lazy(() => import('page/crowdfundingAkademia'));
const AccionesAkademia = React.lazy(() => import('page/AccionesAkademia'));
const HomeAkademia = React.lazy(() => import('page/HomeAkademia'));
const Profile = React.lazy(() => import('page/Profile/User'));
const Information = React.lazy(() => import('page/Profile/User/Information'));
const TransactionHistory = React.lazy(() => import('page/Profile/User/TransactionHistory'));
const Notifications = React.lazy(() => import('page/components/Notification/Notifications'));
const Investments = React.lazy(() => import('page/Profile/User/Investments'));
const WithDraw = React.lazy(() => import('page/Profile/User/WithDraw'));
const SavedProjects = React.lazy(() => import('page/Profile/User/SavedProjects'));
const ChangePassword = React.lazy(() => import('page/Profile/User/ChangePassword'));
const CompleteProfileCol = React.lazy(() => import('page/Profile/User/CompleteProfileCol'));
const CompleteProfilePer = React.lazy(() => import('page/Profile/User/CompleteProfilePer'));

// perfil compañia
const ProfileCompany = React.lazy(() => import('page/Profile/Company/Profile'));
// const CampaignBuilder = React.lazy(() => import('page/Profile/Company/CampaignBuilder'));
const PreRegister = React.lazy(() => import('page/Profile/Company/PreRegister'));

const NotificationsCompany = React.lazy(() => import('page/components/Notification/Notifications'));
const TransactionHistoryCompnay = React.lazy(() => import('page/Profile/Company/TransactionHistory'));
const InformationCompany = React.lazy(() => import('page/Profile/Company/Information'));
const Inversionists = React.lazy(() => import('page/Profile/Company/Inversionists'));
const CompanyBonds = React.lazy(() => import('page/Profile/Company/Bonds'));
const ProjectPreview = React.lazy(() => import('page/Profile/Company/ProjectPreview'));
const Projects = React.lazy(() => import('page/Projects'));
const ProjectCategories = React.lazy(() => import('page/ProjectCategory'));
const IdentityVerification = React.lazy(() => import('page/IdentityVerification'));
const FinancialInfoCompletion = React.lazy(() => import('page/FinancialInfoCompletion'));
const ClearCache = React.lazy(() => import('page/ClearCache'));

export default function App() {
  const { isLoadingToken, acceptedError } = usePortalToken();
  const { location, setLocation } = useLocation();
  const [currentLocation] = useLoc();

  useEffect(() => {
    setLocation({
      previous: location.current,
      current: currentLocation,
    });
  }, [currentLocation]);

  if (isLoadingToken) {
    return (
      <Box
        height="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Loading />
      </Box>
    );
  }

  return (
    <ConstructionGate>
      <div>
        {acceptedError === 'INACTIVE' && <MaintenanceModal />}
        <GlobalStyle />
        <SessionExpiresModal />
        <ButtonWhatsapp />
        <HelmetProvider>
          <Switch>
            <PageAkademia
              path={routes.acakademiaCrowd}
              title="Crowdfunding"
              component={withSuspense(CrowdfundingAkademia)}
            />
            <PageAkademia
              path={routes.acakademiaAcciones}
              title="Acciones"
              component={withSuspense(AccionesAkademia)}
            />
            <PageAkademia
              path={routes.acakademiaHome}
              description="Practica tus decisiones de inversión de forma colaborativa en proyectos definidos por tu profesor, a través de Akademia, el simulador educativo de inversiones. Descubre oportunidades de inversión virtual y aprende sin arriesgar dinero real. ¡Comienza a construir tu criterio financiero hoy mismo con Akademia!"
              component={withSuspense(HomeAkademia)}
            />
            <PageAkademia
              path={routes.acakademiaLanding}
              description="Practica tus decisiones de inversión de forma colaborativa en proyectos definidos por tu profesor, a través de Akademia, el simulador educativo de inversiones. Descubre oportunidades de inversión virtual y aprende sin arriesgar dinero real. ¡Comienza a construir tu criterio financiero hoy mismo con Akademia!"
              component={withSuspense(AkademiaHome)}
              noNavBar
            />
            <Page
              component={withSuspense(InConstruction)}
              path="/en-construccion"
            />
            <Page
              path={routes.home}
              description="Practica tus decisiones de inversión de forma colaborativa en proyectos definidos por tu profesor, a través de Akademia, el simulador educativo de inversiones. Descubre oportunidades de inversión virtual y aprende sin arriesgar dinero real. ¡Comienza a construir tu criterio financiero hoy mismo con Akademia!"
              component={withSuspense(HomePage)}
            />
            <Page
              title="Financia tu proyecto"
              description="En Akademia, aprende cómo se financian los proyectos a través del crowdfunding. Explora cómo funciona el proceso y contribuye a tu aprendizaje financiero de forma práctica y colaborativa."
              component={withSuspense(FinanceProject)}
              path={routes.financeProject}
            />
            <Page
              title="Completar Perfil"
              noFooter
              component={withProfile(CompleteProfileCol, [userType.USER])}
              path={routes.completeProfileCol}
            />
            <Page
              title="Completar Perfil"
              component={withProfile(CompleteProfilePer, [userType.USER])}
              path={routes.completeProfilePer}
            />
            <Page
              title="Términos y condiciones"
              component={withSuspense(TermsAndConditions)}
              path={routes.termsAndConditions}
            />
            <Page
              title="Política de tratamiento de datos"
              component={withSuspense(DataProcessingPolicy)}
              path={routes.dataProcessingPolicy}
            />
            <Page
              title="Contáctanos"
              component={withSuspense(SendMessage)}
              path={routes.message.contactUs}
              description="¿Tienes preguntas sobre cómo funciona Akademia? Estamos aquí para ayudarte. Ponte en contacto con nosotros en la sección 'Contáctanos'. Nuestro equipo está listo para responder a cualquier consulta y brindarte la asistencia que necesitas mientras practicas tus decisiones de inversión."
            />
            <Page
              title="Empleos"
              component={withSuspense(SendMessage)}
              path={routes.message.team}
              description="¿Interesado en ser parte del equipo de Akademia? Cuéntanos sobre ti a través de nuestro formulario, aunque no tengamos vacantes abiertas ahora, nos encantaría conocerte y tenerte en cuenta a futuro."
            />
            <Page
              title="Quejas"
              component={withSuspense(ComplaintsForm)}
              path={routes.message.complaints}
              description=""
            />
            <Page
              title="Quiénes Somos"
              component={withSuspense(WhatDo)}
              path={routes.aboutUs}
              description="En Akademia, nuestra misión es que aprendas a invertir practicando con un presupuesto virtual, sin arriesgar dinero real. Explora nuestra misión, visión y valores, junto con las entidades que forman parte de nuestra red educativa."
            />
            <Page
              title="Preguntas frecuentes"
              component={withSuspense(FrequentQuestions)}
              path={routes.frequentQuestions}
              description="Encuentra respuestas a tus preguntas sobre cómo invertir dentro de Akademia en nuestra sección de 'Preguntas Frecuentes'. Explora cómo funciona el simulador, las oportunidades de inversión virtual y todo lo que necesitas para comenzar a practicar."
            />
            <Page
              title="Recursos"
              component={withSuspense(Resources)}
              path={routes.resources}
              description="Explora nuestra sección de Información de Productos y Servicios para conocer las guías y el reglamento del simulador. Si alguna vez necesitas ayuda, estamos aquí para ti. ¡Descubre cómo sacarle el máximo provecho a tu experiencia de aprendizaje en Akademia!"
            />
            <Page
              title="Nuestros corresponsales"
              component={withSuspense(Correspondents)}
              path={routes.correspondents}
              description="Conoce las entidades que forman parte de la red educativa de Akademia. Juntos te ayudamos a practicar y aprender sobre el mundo financiero."
            />
            <Page
              title="Garantía"
              component={withSuspense(Warranty)}
              path={`${routes.warranty.route}${routes.warranty.params}`}
              description="Descubre cómo funcionan las garantías dentro de la simulación de inversión colaborativa en Akademia. En esta sección te explicamos, de forma educativa, cómo se protegen las inversiones en un entorno de crowdfunding real."
            />
            <Page
              title="Condiciones y características"
              component={withSuspense(ConditionsAndCharacteristics)}
              path={`${routes.conditionsAndCharacteristics.route}${routes.conditionsAndCharacteristics.params}`}
              description=""
            />

            {/* Inversionista */}
            <Page
              noFooter
              component={withProfile(Profile, [userType.USER])}
              path={routes.profile.route}
              title="Mi perfil"
              description="En la sección 'Mi Perfil' de Akademia, gestiona tus inversiones virtuales de manera eficiente, realiza un seguimiento de tus inversiones actuales y edita tu información según sea necesario."
            />
            <Page
              noFooter
              component={withProfile(Information, [userType.USER])}
              path={routes.profile.information}
              title="Mi información"
            />
            <Page
              noFooter
              component={withProfile(TransactionHistory, [userType.USER])}
              path={routes.profile.wallet}
              title="Mi cartera"
            />

            <Page
              noFooter
              title="Verificación de identidad"
              path={routes.dataCompletion.idVerification}
              component={withSuspense(IdentityVerification)}
            />
            <Page
              noFooter
              title="Completar información financiera"
              path={routes.dataCompletion.financialInfoCompletion}
              component={withSuspense(withPrivateRoute(FinancialInfoCompletion))}
            />
            <Page
              noFooter
              component={withProfile(Notifications, [userType.USER])}
              path={routes.profile.notifications}
              title="Notificaciones"
            />
            <Page
              noFooter
              component={withProfile(Investments, [userType.USER])}
              path={routes.profile.invert}
              title="Mis inversiones"
            />
            <Page
              noFooter
              component={withProfile(WithDraw, [userType.USER])}
              path={routes.profile.withDraw}
              title="Retirar dinero"
            />
            <Page
              noFooter
              component={withProfile(SavedProjects, [userType.USER])}
              path={routes.profile.savedProjects}
              title="Proyectos guardados"
            />
            <Page
              title="Cambiar contraseña"
              component={withProfile(ChangePassword, [userType.USER])}
              path={routes.profile.changePassword}
            />

            {/* Empresa */}
            <Page
              title="Mi empresa"
              noFooter
              component={withProfile(ProfileCompany, [userType.COMPANY])}
              path={routes.profileCompany.route}
            />
            <Page
              title="Creador de campaña"
              noFooter
              component={withProfile(PreRegister, [userType.COMPANY])}
              path={routes.profileCompany.campaignBuilder}
            />
            {/* <Page
              title="Mis actualizaciones"
              noFooter
              component={withProfile(Updates, [userType.COMPANY])}
              path={routes.profileCompany.updates}
            /> */}
            <Page
              title="Mi historial"
              noFooter
              component={withProfile(TransactionHistoryCompnay, [
                userType.COMPANY,
              ])}
              path={routes.profileCompany.transactionHistory}
            />

            <Page
              title="Mis inversionistas"
              noFooter
              component={withProfile(Inversionists, [userType.COMPANY])}
              path={routes.profileCompany.inversionists}
            />
            <Page
              title="Mi Informacion"
              noFooter
              component={withProfile(InformationCompany, [userType.COMPANY])}
              path={routes.profileCompany.information}
            />
            <Page
              title="Mis notificaciones"
              noFooter
              component={withProfile(NotificationsCompany, [userType.COMPANY])}
              path={routes.profileCompany.notifications}
            />
            <Page
              title="Mis emisiones"
              noFooter
              component={withProfile(CompanyBonds, [userType.COMPANY])}
              path={routes.profileCompany.bonds}
            />
            <Page
              title="Previsualizacion de proyecto"
              noFooter
              component={withSuspense(withPrivateRoute(ProjectPreview))}
              path={routes.profileCompany.projectPreview}
            />
            <Page
              title="Proyectos"
              component={withSuspense(Projects)}
              path={routes.project.allProjects}
            />
            <Page
              noNavBar
              title="Proyectos"
              component={withSuspense(ProjectCategories)}
              path={routes.project.categorization.params}
            />
            <Page
              noNavBar
              title="Akademia"
              path={routes.clearCache}
              component={withSuspense(ClearCache)}
            />
            <Page
              title="Proyecto"
              component={withSuspense(Project)}
              path="/:tag"
            />
            <Route component={Error} />
          </Switch>
        </HelmetProvider>
      </div>
    </ConstructionGate>
  );
}
